<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-28 09:11:11
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-02-09 12:35:21
 * @FilePath: \H5\src\views\rewards.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="Photo" @click="hClick" v-if="list.trace_reward_info.reward_image">
    <img
      :src="list.trace_reward_info.reward_image"
      alt
      style="width: 100%; height: 100%"
    />
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      list: null,
    };
  },
  created() {
    this.list = JSON.parse(window.localStorage.getItem("reData"));
    console.log("gggg", this.list.trace_reward_info.id);
  },
  methods: {
    async hClick() {
      let data = {
        // reward_id: this.list.trace_reward_info.reward_id,
        // reward_type: this.list.trace_reward_info.reward_type,
        // amount: this.list.trace_reward_info.amount,
        merchant_id: this.list.wx_merchant_id,
        path: `pages/index/index?reward_id=${this.list.trace_reward_info.reward_id}&reward_type=${this.list.trace_reward_info.reward_type}&amount=${this.list.trace_reward_info.amount}&id=${this.list.trace_reward_info.id}&typeId=1`,
      };
      await axios
        .post(
          "https://apigateway.klyun.com.cn/chain/chainindustry/v1.0.0/api/myshop/TraceCreateWXScheme",
          data
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.message.code === 200) {
            location.href = res.data.data.openlink;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.Photo {
  width: 696px;
  height: 188px;
  margin: 14px auto;
}
</style>